import React, { useEffect } from 'react';
import { getAuth, signOut } from 'firebase/auth';

const auth = getAuth();

const LogoutButton: React.FC = () => {

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log('User signed out successfully');
      
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  useEffect(() => {
  }, []);

  return (
    <button
      onClick={handleLogout}
      className="px-2 py-1 bg-gray-800 text-white rounded-md hover:bg-gray-600"
    >
      Log Out
    </button>
  );
};

export default LogoutButton;
